import { useCallback, useEffect, useState } from "react";

import LockIcon from "@assets/icons/lock-closed.svg";

import { IMeeting, IMeetingUpdatePayload } from "@interfaces/meeting.interface";
import { MEETING_TOOLTIP_TEXT } from "@config/constants";
import { OrganizationLogo } from "@ui/Logos";
import { Switch } from "@ui/Switch";

interface Props {
  meeting?: IMeeting;
  onUpdateMeeting: (meeting: Partial<IMeetingUpdatePayload>) => void;
  isDisabled?: boolean;
}

export function MeetingPrivacySwitcher({ meeting, onUpdateMeeting, isDisabled = false }: Props) {
  const [isPrivate, setIsPrivate] = useState<boolean>((meeting?.is_private as boolean) || true);

  const handleChangeIsPrivate = useCallback(() => {
    if (!meeting) return;

    setIsPrivate((prevState) => !prevState);
    onUpdateMeeting({ is_private: !isPrivate });
  }, [onUpdateMeeting, isPrivate, meeting]);

  useEffect(() => {
    meeting && setIsPrivate(meeting?.is_private);
  }, [meeting?.is_private]);

  return (
    <Switch
      isDisabled={isDisabled}
      state={!isPrivate}
      leftContent={
        <div className="-mr-[1px] flex items-center gap-1">
          <OrganizationLogo />
        </div>
      }
      rightContent={
        <div className="-ml-[1px] flex items-center gap-1">
          <LockIcon width={20} height={20} />
        </div>
      }
      onToggle={handleChangeIsPrivate}
      circleWidth={32}
      switchWidth={70}
      leftTooltip={MEETING_TOOLTIP_TEXT.shared}
      rightTooltip={MEETING_TOOLTIP_TEXT.private}
      leftTooltipPlacement="bottom"
      rightTooltipPlacement="bottom"
      rightTooltipContentClassName="w-48"
      isInverted
    />
  );
}
